import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AjaxContext, AppContext, UserContext } from 'commons-ui';
import _get from 'lodash/get';
import { allertType, csvFailedMessage, csvUploadSuccessMessage, uploadCsvURI } from '../../utils/constants';

const useCreate = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);
	const { user } = useContext(UserContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();

	const handleFormSubmit = async (submittedData: any) => {
		try {
			const { csv } = submittedData;
			const formData = new FormData();
			formData.append('createdBy', _get(user, 'email', ''));
			formData.append('csv', csv);
			setShowLoader(true);
			const response = await postData({
				endpoint: uploadCsvURI,
				customHeaders: { 'Content-Type': 'multipart/form-data' },
				queryParams: {
					appName
				},
				body: formData
			});
			const err: boolean = response?.data && response?.data?.success;
			if (!err) {
				showAlert(`${csvFailedMessage}${response?.data?.error}`, {
					type: allertType
				});
			} else {
				showAlert(csvUploadSuccessMessage);
				history.goBack();
			}
		} catch (error: any) {
			showAlert(`${csvFailedMessage}${error?.response?.data?.error}`, { type: allertType });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
